<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Rocket" class="d-icon d-icon--rocket" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.089 7.5a1.487 1.487 0 0 0-1.005.35c-.246.207-.424.49-.556.759a5.17 5.17 0 0 0-.31.834 7.918 7.918 0 0 0-.21.966l-.003.017v.008a.5.5 0 0 0 .562.562h.002l.005-.002.017-.002a4.771 4.771 0 0 0 .276-.047c.178-.034.423-.087.69-.163a5.13 5.13 0 0 0 .833-.311c.269-.131.551-.31.758-.556.477-.566.485-1.447-.072-1.997l-.006-.006a1.487 1.487 0 0 0-.981-.411ZM2.28 9.82a6.238 6.238 0 0 1-.14.04 4.181 4.181 0 0 1 .287-.812c.102-.21.207-.354.3-.433a.487.487 0 0 1 .648.017.483.483 0 0 1 .007.638v.002c-.08.094-.223.198-.432.3-.204.1-.44.183-.67.249Z" fill="currentColor"/><path fill-rule="evenodd" clip-rule="evenodd" d="M8.392 6.72C10.645 5.007 11 2.783 11 1.5a.5.5 0 0 0-.497-.5 6.445 6.445 0 0 0-5.236 2.632l-.032-.007a6.576 6.576 0 0 0-.685-.108c-.507-.052-1.25-.063-1.806.268-.512.305-.813.888-.98 1.296a5.282 5.282 0 0 0-.25.797L1.51 5.9a.5.5 0 0 0 .49.6h2.178L5.5 7.822V10a.5.5 0 0 0 .6.49h.002l.005-.002.015-.003a4.547 4.547 0 0 0 .23-.058 5.07 5.07 0 0 0 .567-.192c.408-.166.99-.467 1.296-.979.33-.553.326-1.304.28-1.818a6.908 6.908 0 0 0-.099-.696l-.004-.023Zm1.585-4.698a5.445 5.445 0 0 0-4.13 2.536l-.003.004a9.654 9.654 0 0 0-.756 1.434l.917.918c.504-.211.99-.464 1.453-.756C9.37 4.873 9.875 3.2 9.978 2.022ZM7.5 7.527a5.47 5.47 0 0 0-.023-.217c-.317.176-.643.336-.976.48v1.535l.042-.016c.376-.153.687-.352.814-.565.153-.257.187-.72.143-1.217ZM2.674 5.5h1.538c.144-.327.303-.647.478-.958a5.195 5.195 0 0 0-.241-.03c-.487-.05-.938-.02-1.193.132-.213.127-.412.438-.565.814l-.017.042Z" fill="currentColor"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconRocket',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
